export const MODEL_GROUPS_QK = 'modelGroups';
export const ORION_MODEL_OPTIONS_QK = 'orionModelOptions';

export const queryKeys = {
  modelGroups: () => [MODEL_GROUPS_QK],
  orionModelOptions: () => [ORION_MODEL_OPTIONS_QK],
};
